"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PostcodeEpcAttributes$ = exports.PostcodeEpcAttributes$outboundSchema = exports.PostcodeEpcAttributes$inboundSchema = void 0;
exports.postcodeEpcAttributesToJSON = postcodeEpcAttributesToJSON;
exports.postcodeEpcAttributesFromJSON = postcodeEpcAttributesFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const rfcdate_js_1 = require("../../types/rfcdate.js");
const energyefficiencyratings_js_1 = require("./energyefficiencyratings.js");
/** @internal */
exports.PostcodeEpcAttributes$inboundSchema = z.object({
    address: z.nullable(z.string()),
    current_efficiency: z.number().int(),
    current_rating: energyefficiencyratings_js_1.EnergyEfficiencyRatings$inboundSchema,
    expired: z.boolean(),
    expiry_date: z.string().transform(v => new rfcdate_js_1.RFCDate(v)),
    lmk_key: z.nullable(z.string()),
    lodgement_date: z.string(),
    postcode: z.nullable(z.string()),
    potential_efficiency: z.number().int(),
    potential_rating: energyefficiencyratings_js_1.EnergyEfficiencyRatings$inboundSchema,
    street_group_property_id: z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "current_efficiency": "currentEfficiency",
        "current_rating": "currentRating",
        "expiry_date": "expiryDate",
        "lmk_key": "lmkKey",
        "lodgement_date": "lodgementDate",
        "potential_efficiency": "potentialEfficiency",
        "potential_rating": "potentialRating",
        "street_group_property_id": "streetGroupPropertyId",
    });
});
/** @internal */
exports.PostcodeEpcAttributes$outboundSchema = z.object({
    address: z.nullable(z.string()),
    currentEfficiency: z.number().int(),
    currentRating: energyefficiencyratings_js_1.EnergyEfficiencyRatings$outboundSchema,
    expired: z.boolean(),
    expiryDate: z.instanceof(rfcdate_js_1.RFCDate).transform(v => v.toString()),
    lmkKey: z.nullable(z.string()),
    lodgementDate: z.string(),
    postcode: z.nullable(z.string()),
    potentialEfficiency: z.number().int(),
    potentialRating: energyefficiencyratings_js_1.EnergyEfficiencyRatings$outboundSchema,
    streetGroupPropertyId: z.string().optional(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        currentEfficiency: "current_efficiency",
        currentRating: "current_rating",
        expiryDate: "expiry_date",
        lmkKey: "lmk_key",
        lodgementDate: "lodgement_date",
        potentialEfficiency: "potential_efficiency",
        potentialRating: "potential_rating",
        streetGroupPropertyId: "street_group_property_id",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var PostcodeEpcAttributes$;
(function (PostcodeEpcAttributes$) {
    /** @deprecated use `PostcodeEpcAttributes$inboundSchema` instead. */
    PostcodeEpcAttributes$.inboundSchema = exports.PostcodeEpcAttributes$inboundSchema;
    /** @deprecated use `PostcodeEpcAttributes$outboundSchema` instead. */
    PostcodeEpcAttributes$.outboundSchema = exports.PostcodeEpcAttributes$outboundSchema;
})(PostcodeEpcAttributes$ || (exports.PostcodeEpcAttributes$ = PostcodeEpcAttributes$ = {}));
function postcodeEpcAttributesToJSON(postcodeEpcAttributes) {
    return JSON.stringify(exports.PostcodeEpcAttributes$outboundSchema.parse(postcodeEpcAttributes));
}
function postcodeEpcAttributesFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.PostcodeEpcAttributes$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'PostcodeEpcAttributes' from JSON`);
}
//# sourceMappingURL=postcodeepcattributes.js.map